import React from 'react';

import { type BaseCurrencyType } from '@pkg/types';
import { clamp } from '@pkg/utils';

import { CurrencyIcon } from '../CurrencyIcon';

import { IconWrapper, StyledCurrencyAvatar } from './CurrencyAvatar.style';

export interface CurrencyAvatarProps {
    currency?: BaseCurrencyType;
    size?: number;
    invertTheme?: boolean;
}

export function CurrencyAvatar({ currency = 'usd', size = 16, invertTheme = false }: CurrencyAvatarProps) {
    const safeSize = clamp(14, size, 140);

    const glyph = safeSize < 40;
    const theme = invertTheme ? 'dark' : 'light';

    return (
        <StyledCurrencyAvatar $invertTheme={invertTheme} $size={safeSize}>
            <IconWrapper>
                <CurrencyIcon currency={currency} theme={glyph ? 'glyph' : theme} />
            </IconWrapper>
        </StyledCurrencyAvatar>
    );
}
